import React from "react"
import {
  Container,
  Typography,
  MuiThemeProvider,
  makeStyles,
} from "@material-ui/core"
import Chips from "components/Chips"
import Footer from "components/Footer"
import SEO from "components/gatsby/SEO"
import { themeColor } from "services/constants"
import ArifOcean from "assets/img/arif-ocean.jpg"
import Family from "assets/img/family.jpg"
import Cat from "assets/img/cat.jpg"
import Coffee from "assets/img/coffee.jpg"

interface Props {
  data: any
}

const useStyles = makeStyles({
  container: {
    display: "flex",
    justifyContent: "space-between",
    position: "relative",
    padding: 0,
    margin: 0,
  },
  bgArifOcean: {
    position: "relative",
    backgroundImage: `url(${ArifOcean})`,
    backgroundPosition: "center top",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    boxShadow: "1px 1px 10px 2px rgb(51 51 51 / 50%)",
  },
  bgFamily: {
    position: "relative",
    backgroundImage: `url(${Family})`,
    backgroundPosition: "center top",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    boxShadow: "1px 1px 10px 2px rgb(51 51 51 / 50%)",
  },
  bgCoffee: {
    position: "relative",
    backgroundImage: `url(${Coffee})`,
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    boxShadow: "1px 1px 10px 2px rgb(51 51 51 / 50%)",
  },
  bgCat: {
    position: "relative",
    backgroundImage: `url(${Cat})`,
    backgroundPosition: "center top",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    boxShadow: "1px 1px 10px 2px rgb(51 51 51 / 50%)",
  },
  column: {
    flexDirection: "row",
  },
  columnReverse: {
    flexDirection: "row",
  },
  aboutMeOuter: {
    paddingLeft: "0 !important",
    paddingRight: "0 !important",
    position: "relative",
  },
  borderedLeft: {
    borderTopLeftRadius: "50px",
    borderBottomLeftRadius: "50px",
  },
  borderedRight: {
    borderTopRightRadius: "50px",
    borderBottomRightRadius: "50px",
  },
  sectionHeight: {
    height: "500px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  aboutMeDesc: {
    fontSize: "1.5rem !important",
    fontFamily: "Quicksand, Sans-Serif !important",
    margin: "1rem",
  },
  "@media screen and (min-width: 320px)": {
    container: {
      display: "flex",
      justifyContent: "space-between",
      position: "relative",
      padding: 0,
      margin: 0,
    },
    columnReverse: {
      flexDirection: "column-reverse",
    },
    column: {
      flexDirection: "column",
    },
    aboutMeOuter: {
      height: "300px",
    },
    sectionHeight: {
      height: "300px",
    },
    aboutMeDesc: {
      fontSize: "1rem !important",
      textAlign: "center",
      fontFamily: "Quicksand, Sans-Serif !important",
      margin: "1rem",
    },
  },
  "@media screen and (min-width: 475px)": {
    container: {
      display: "flex",
      justifyContent: "space-between",
      position: "relative",
      padding: 0,
      margin: 0,
    },
    column: {
      flexDirection: "row",
    },
    columnReverse: {
      flexDirection: "row",
    },
    aboutMeOuter: {
      height: "500px",
    },
    sectionHeight: {
      height: "500px",
    },
    aboutMeDesc: {
      fontSize: "1.5rem !important",
      textAlign: "center",
      fontFamily: "Quicksand, Sans-Serif !important",
      margin: "1rem",
    },
  },
})

const AboutMe: React.FC<Props> = () => {
  const classes = useStyles()

  return (
    <MuiThemeProvider theme={themeColor}>
      <SEO title="Blog" />
      <Chips />
      {/* First Section */}
      <Container
        className={`${classes.container} ${classes.columnReverse}`}
        maxWidth="xl"
      >
        <Container
          maxWidth={false}
          className={`${classes.aboutMeOuter} ${classes.sectionHeight}`}
        >
          <Typography
            className={classes.aboutMeDesc}
            variant="h5"
            color="textPrimary"
            align="center"
            paragraph
          >
            I love to travel<span role="img">✈️</span>
          </Typography>
        </Container>
        <Container
          maxWidth={false}
          className={`${classes.aboutMeOuter} ${classes.bgArifOcean} ${classes.borderedLeft}`}
        >
          {/*  */}
        </Container>
      </Container>
      {/* Second Section */}
      <Container
        className={`${classes.container} ${classes.column}`}
        maxWidth="xl"
      >
        <Container
          maxWidth={false}
          className={`${classes.aboutMeOuter} ${classes.bgFamily} ${classes.borderedRight}`}
        >
          {/*  */}
        </Container>
        <Container
          maxWidth={false}
          className={`${classes.aboutMeOuter} ${classes.sectionHeight}`}
        >
          <Typography
            className={classes.aboutMeDesc}
            variant="h5"
            color="textPrimary"
            align="center"
            paragraph
          >
            I'm married to a gorgeous woman, Fatin
            <span role="img">💑</span> and a father to one beatiful baby, Maryam
            <span role="img">👧</span>
          </Typography>
        </Container>
      </Container>
      {/* Third Section */}
      <Container
        className={`${classes.container} ${classes.columnReverse}`}
        maxWidth="xl"
      >
        <Container
          maxWidth={false}
          className={`${classes.aboutMeOuter} ${classes.sectionHeight}`}
        >
          <Typography
            className={classes.aboutMeDesc}
            variant="h5"
            color="textPrimary"
            align="center"
            paragraph
          >
            I works best with a cup of coffee on my side
            <span role="img">☕</span>
          </Typography>
        </Container>
        <Container
          maxWidth={false}
          className={`${classes.aboutMeOuter} ${classes.bgCoffee} ${classes.borderedLeft}`}
        >
          {/*  */}
        </Container>
      </Container>
      {/* Fourth Section */}
      <Container
        className={`${classes.container} ${classes.column}`}
        maxWidth="xl"
      >
        <Container
          maxWidth={false}
          className={`${classes.aboutMeOuter} ${classes.bgCat}  ${classes.borderedRight}`}
        >
          {/*  */}
        </Container>
        <Container
          maxWidth={false}
          className={`${classes.aboutMeOuter} ${classes.sectionHeight}`}
        >
          <Typography
            className={classes.aboutMeDesc}
            variant="h5"
            color="textPrimary"
            align="center"
            paragraph
          >
            I am a cat lover<span role="img">🐱</span>
          </Typography>
        </Container>
      </Container>
      <Footer />
    </MuiThemeProvider>
  )
}

export default AboutMe
